const addToCartForms = document.querySelectorAll('.addToCartForm');
const updateCartDrawer = async () => {
    let drawerclass = document.querySelector("#CartDrawer");
    const req = await fetch('/cart?view=ajax');
    const res = await req.text();

    const resText = new DOMParser();
    const Doc = resText.parseFromString(res, 'text/html');

    const count = Doc.querySelector('.cart__items').dataset.count;
    const subtotal = Doc.querySelector('.cart__items').dataset.cartSubtotal;
    drawerclass.querySelector('[data-subtotal]').innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
    drawerclass.querySelector('.cart__items').innerHTML = Doc.querySelector('.cart__items').innerHTML
    drawerclass.querySelector('.cart__items').dataset.count = count
    drawerclass.querySelector('.cart__items').dataset.cartSubtotal = subtotal

    new theme.CartDrawer();

    const cartBubbles = document.querySelectorAll('.cart-link__bubble')
    Array.from(cartBubbles).forEach(function(cartBubble) {
        if(count > 0) {
            cartBubble.classList.add('cart-link__bubble--visible')
        }
    })
}
Array.from(addToCartForms).forEach(function(addToCartForm) {
    addToCartForm.addEventListener('submit', async function(e) {
        e.preventDefault()
        let drawerclass = document.querySelector("#CartDrawer");
        const id = this.querySelector('[name="id"]').value
        const selling_plan = this.querySelector('[name="selling_plan"]').value

        const item = {
            "id": id,
            "quantity": 1
        };
        if(selling_plan) {
            item['selling_plan'] = selling_plan
        }
        const items = {
            "items": [item]
        }
        console.log(items);
        const req = await fetch('/cart/add.json', {
            method: "POST",
            headers: {
                "Content-type": "application/json"
            },
            body: JSON.stringify(items)
        });
        const res = await req.json();
        // window.location = '/cart';
        await updateCartDrawer();
        drawerclass.classList.remove('is-empty')
        document.querySelector('.js-drawer-open-cart').click();
    })
})

// change newsletter button text
$('.page-crewe-fitness .newsletter-section .input-group-btn .btn').html('<span>START FREE TRIAL</span>')

$( document ).ready(function() {
  // $('.video___slider').click(function(){
  //  setTimeout(function() {

  //      $("video___slider").each(function(){
  //         $(this).get(0).pause();
  //     });
    
     
  //    $('.video_slider_inner .slick-active video').get(0).play(); alert('hi') }, 1000);
    
     
  // });

    $('.video_slider_mw_thumb video').click(function(){
  ;
      $(".video___slider").each(function(){
            $(this).get(0).pause();
     });
    
    });

  });

// $('.video___slider').click(function()
//     $('.video_slider_inner .video_slider_mw.not(.slick-current).not(.slick-active) .video___slider').pause();                      
//   {this.paused?this.play():this.pause();
// });


if (window.matchMedia('(max-width: 992px)').matches) {
    // text with column section
    let textColumnSec = document.querySelector(".section_height_auto");
    if(textColumnSec){
        textColumnSec.parentElement.style.cssText = `
                                                background-color: #FFE2FC;
                                                padding-bottom: 20px !important;`
    }
}
